/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2499
 */

var r = require(/* 997 */"./2501/997")
var /* [auto-meaningful-name] */Object$prototype$hasOwnProperty = Object.prototype.hasOwnProperty
module.exports = function (e) {
  var /* [auto-meaningful-name] */this$__data__ = this.__data__
  if (r) {
    var n = this$__data__[e]
    return "__lodash_hash_undefined__" === n ? undefined : n
  }
  return Object$prototype$hasOwnProperty.call(this$__data__, e) ? this$__data__[e] : undefined
}
